export const quantize = (value, size = 10) => {
	return Math.round(value / size) * size;
};
